export interface NetworkStudyLink {
    identifier: string;
    link: string;
    permissions: NetworkLinkPermissions;
}

export interface NetworkLinkPermissions {
    viewEntries: boolean;
    editCases: boolean;
    exportPermissions: boolean;
    manageInvestPermissions: boolean;
    forms: boolean | string[];
    editForms: boolean | string[];
}

interface ILinkPermissions {
    viewEntries: boolean;
    export: boolean;
    manageInvest: boolean;
    editCases: boolean;
    forms: boolean | string[];
    editForms: boolean | string[];
}

interface IStudyLink {
    identifier: string;
    link: string;
    permissions: ILinkPermissions;
}

export class StudyLink {
  identifier: string;
  link: string;
  permissions: ILinkPermissions;

  constructor({
    identifier,
    link,
    permissions
  }: IStudyLink) {
    this.identifier = identifier;
    this.link = link;
    this.permissions = permissions;
  }

  static mapFromBackend(networkStudyLink: NetworkStudyLink) {
    const permissions: ILinkPermissions = {
      viewEntries: networkStudyLink.permissions.viewEntries,
      export: networkStudyLink.permissions.exportPermissions,
      manageInvest: networkStudyLink.permissions.manageInvestPermissions,
      editCases: networkStudyLink.permissions.editCases,
      forms: networkStudyLink.permissions.forms,
      editForms: networkStudyLink.permissions.editForms
    };
    return new StudyLink({
      identifier: networkStudyLink.identifier,
      link: networkStudyLink.link,
      permissions
    });
  }
}
